import { ChangeDetectionStrategy, Component, inject, resource, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { DataService } from '../../../services/data.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-flat',
  imports: [CommonModule, RouterOutlet, RouterModule, HeaderComponent, FooterComponent, MatSidenavModule, MatButtonModule, MatIconModule, MatDividerModule],
  templateUrl: './flat.component.html',
  styles: `
    mat-drawer {
      border-radius: 0px !important;
    }

    mat-divider {
      margin-block: calc(var(--spacing) * 5);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DataService]
})
export default class FlatComponent {
  currentRoute = signal('');
  sidenavOpened = signal(false);

  private dataService = inject(DataService);

  constructor(private router: Router) {
    this.currentRoute.set(this.router.url);

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute.set(event.url);
      });
  }

  configResource = resource({
    request: () => ({}),
    loader: async() => {
      /*const response = await fetch(this.dataService.getPageUrl('flat'));
      return await response.json();*/

      return this.dataService.getPageInfo('flat');
    },
  });
  
  dataResource = resource({
    request: () => ({url: this.currentRoute()}),
    loader: async(request) => {
      /*const response = await fetch(this.dataService.getPageUrl(request.request.url));
      return await response.json();*/

      return this.dataService.getPageInfo(request.request.url);
    },
  });

  get logo() {
    return (this.configResource.value() as any)?.logos?.logo;
  }

  closeSidenav () {
    this.sidenavOpened.set(false);
  }
}
